<template>
  <div>
    <vs-breadcrumb class="mb-6" :items="
   [
     {
       title: '营销中心',
       url: '/sales/coupon'
     },
     {
       title: '优惠券',
       active: true
     }
   ]"></vs-breadcrumb>
    <div>

    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        list: [],
        itemsPerPage: 20,
        noDataText: ''
      }
    }
  }

</script>
<style scoped>

</style>
